import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { fontFamily, fontSize } from '../../../constants/text';
import styled from 'styled-components';
import Grid from '@material-ui/core/Grid';
import { colors } from '../../../constants/colors';
import { campaignNames } from '../../../core/analytics/events';
import { emptyFunction } from '../../../core/util/function';
import AppStoreBadge from '../../DownloadDriver/AppStoreBadge';
import SocialMedia from './SocialMedia';
import Copyright from './Copyright';
import PrivacyLinks from './PrivacyLinks';
import Header from './Header';
import { DESKTOP_FAT_GUTTER, DESKTOP_THIN_GUTTER } from '../../../constants/layout';
import {
  FIND_PATH,
  URGENT_CARE_NEAR_ME_PATH,
  PEDIATRIC_NEAR_ME_PATH,
  BLOG_PATH,
  FAQ_PATH,
  HELP_PATH,
  CLAIM_PATH,
  FOR_PROVIDERS_BLOG_PATH,
  CAREERS_PATH,
  FOR_PROVIDERS_PATH,
  ABOUT_US_PATH,
  LOCATIONS_DIRECTORY_PATH,
  WALK_IN_CLINIC_NEAR_ME_PATH,
  HEALTH_AZ_PATH,
  VIDEO_TELEMEDICINE_PATH,
  URGENT_CARE_OPEN_NOW_PATH,
  PEDIATRIC_OPEN_NOW_PATH,
  WALK_IN_CLINIC_OPEN_NOW_PATH,
  VA_URGENT_CARE_NEAR_ME_PATH,
} from '../../../constants';
import { BASE_URL } from '../../../config';
import { breakpoints } from '../../../core/util/styledComponents';
import { getCityDirectoryUrl } from '../../../core/util/seo';
import { biggerThan } from '../../../core/util/styledComponents';

const StyledFooter = styled.div`
  background-color: ${colors.myRightFoot};
  color: ${colors.white};
  font-family: ${fontFamily.book};
  -webkit-font-smoothing: antialiased;
  line-height: 18px;
  font-size: ${fontSize.small};
  padding-top: 26px;
  padding-bottom: 34.5px;
  padding-right: ${DESKTOP_FAT_GUTTER}px;
  padding-left: ${DESKTOP_FAT_GUTTER}px;
  ${biggerThan.lg`
    padding-right: ${DESKTOP_THIN_GUTTER}px;
    padding-left: ${DESKTOP_THIN_GUTTER}px;
  `};
  text-align: center;
  span:last-child {
    padding-top: 6px;
  }
`;

const StyledPrivacyLinks = styled(PrivacyLinks)`
  ${biggerThan.sm`
    a:not(:last-child) {
      :after {
        content: "|";
        padding-left: 5px;
        padding-right: 5px;
      }
    }
  `}
`;

const SectionTitle = styled.h5`
  color: ${colors.white}!important;
  font-family: ${fontFamily.bold}!important;
  -webkit-font-smoothing: antialiased;
  font-size: ${fontSize.default};
  font-family: ${fontFamily.bold};
  line-height: 20px;
  margin-bottom: 10px;
  a {
    cursor: pointer;
    color: ${colors.white}!important;
    text-decoration: none;
  }
  a:visited {
    color: ${colors.borderLine}!important;
  }
`;

const Link = styled.div`
  color: ${colors.borderLine}!important;
  font-family: ${fontFamily.bold};
  -webkit-font-smoothing: antialiased;
  line-height: 24px;
  font-size: 12px;
  a {
    cursor: pointer;
    color: ${colors.borderLine};
    text-decoration: none;
  }
  a:visited {
    color: ${colors.borderLine}!important;
  }
`;

const ContentContainer = styled(Grid)`
  max-width: ${breakpoints.lg};
  margin: 0 auto;
`;

const Sections = styled(Grid)`
  padding-bottom: 24px;
  padding-right: ${DESKTOP_FAT_GUTTER}px;
  padding-left: ${DESKTOP_FAT_GUTTER}px;
  ${biggerThan.lg`
    padding-right: ${DESKTOP_THIN_GUTTER}px;
    padding-left: ${DESKTOP_THIN_GUTTER}px;
  `};
  background-color: ${colors.squid};
  color: ${colors.white};
`;

const DottedDivider = styled.div`
  border-left: 1px dotted ${colors.blueMonday};
  height: 100%;
`;

const PopularCities = styled.div`
  max-width: 300px;
  p {
    margin-top: 0;
    margin-bottom: 0;
  }
  a {
    cursor: pointer;
    color: ${colors.borderLine}!important;
    -webkit-font-smoothing: antialiased;
    font-weight: bold;
    font-family: ${fontFamily.book};
    font-size: 12px;
    line-height: 24px;
  }
  a:visited {
    color: ${colors.borderLine}!important;
  }
`;

const Section = styled(Grid)`
  margin-top: 33px;
`;

const SectionMenu = styled.div`
  margin-top: 5px;
`;

const BottomLinksContainer = styled.div`
  max-width: ${breakpoints.lg};
  margin: 0 auto;
`;

class Desktop extends Component {
  render() {
    return (
      <Fragment>
        <Header />
        <Sections>
          <ContentContainer container>
            <Section item md={2}>
              <SectionTitle>
                <a href={`${BASE_URL}${FIND_PATH}`}>Find Care</a>
              </SectionTitle>
              <SectionMenu>
                <Link>
                  <a href={`${BASE_URL}${URGENT_CARE_NEAR_ME_PATH}`}>Urgent Care Near Me</a>
                </Link>
                <Link>
                  <a href={`${BASE_URL}${PEDIATRIC_NEAR_ME_PATH}`}>Pediatric Urgent Care Near Me</a>
                </Link>
                <Link>
                  <a href={`${BASE_URL}${WALK_IN_CLINIC_NEAR_ME_PATH}`}>Walk-in Clinic Near Me</a>
                </Link>
                <Link>
                  <a href={`${BASE_URL}${VA_URGENT_CARE_NEAR_ME_PATH}`}>VA Urgent Care Near Me</a>
                </Link>
                <Link>
                  <a href={`${BASE_URL}${URGENT_CARE_OPEN_NOW_PATH}`}>Urgent Care Open Now</a>
                </Link>
                <Link>
                  <a href={`${BASE_URL}${PEDIATRIC_OPEN_NOW_PATH}`}>
                    Pediatric Urgent Care Open Now
                  </a>
                </Link>
                <Link>
                  <a href={`${BASE_URL}${WALK_IN_CLINIC_OPEN_NOW_PATH}`}>Walk-in Clinic Open Now</a>
                </Link>
              </SectionMenu>
            </Section>
            <Section item md={2}>
              <SectionTitle>
                <a href={`${BASE_URL}${BLOG_PATH}`}>Resources</a>
              </SectionTitle>
              <SectionMenu>
                <Link>
                  <a href={`${BASE_URL}${BLOG_PATH}`}>Blog</a>
                </Link>
                <Link>
                  <a href={`${BASE_URL}${FAQ_PATH}`}>Health FAQs</a>
                </Link>
                <Link>
                  <a href={`${BASE_URL}${HEALTH_AZ_PATH}`}>Health A-Z</a>
                </Link>
                <Link>
                  <a href={`${BASE_URL}${HELP_PATH}`}>Help</a>
                </Link>
              </SectionMenu>
            </Section>
            <Section item md={2}>
              <SectionTitle>
                <a href={`${BASE_URL}${FOR_PROVIDERS_PATH}`}>For Providers</a>
              </SectionTitle>
              <SectionMenu>
                <Link>
                  <a href={`${BASE_URL}${VIDEO_TELEMEDICINE_PATH}`}>Video Telemedicine</a>
                </Link>
                <Link>
                  <a href={`${BASE_URL}${CLAIM_PATH}`}>Claim Your Listing</a>
                </Link>
                <Link>
                  <a href={FOR_PROVIDERS_BLOG_PATH}>Provider Blog</a>
                </Link>
              </SectionMenu>
            </Section>
            <Section item md={2}>
              <SectionTitle>
                <a href={`${BASE_URL}${ABOUT_US_PATH}`}>About Us</a>
              </SectionTitle>
              <SectionMenu>
                <Link>
                  <a href={`${BASE_URL}${CAREERS_PATH}`}>Careers</a>
                </Link>
                <Link>
                  <a href="mailto:support@solvhealth.com">Contact</a>
                </Link>
              </SectionMenu>
              <SectionTitle>Get Our App</SectionTitle>
              <SectionMenu>
                <AppStoreBadge campaignName={campaignNames.DESKTOP_FOOTER} />
              </SectionMenu>
            </Section>
            <Section item md={1}>
              <DottedDivider />
            </Section>
            <Section item md={3}>
              <SectionTitle>Popular Cities</SectionTitle>
              <PopularCities>
                <Grid container align-items="flex-start">
                  {this.props.popularCities.map(popular => (
                    <Grid item xs={6} key={popular.id}>
                      <p>
                        <a
                          key={popular.id}
                          href={
                            BASE_URL +
                            getCityDirectoryUrl(popular.state, popular.city.toLowerCase())
                          }
                          onClick={() => this.props.onPopularCityClick(popular.city, popular.state)}
                        >
                          {popular.city}
                        </a>
                      </p>
                    </Grid>
                  ))}
                  <Grid item xs={6}>
                    <p>
                      <a href={`${BASE_URL}${LOCATIONS_DIRECTORY_PATH}`}>All locations...</a>
                    </p>
                  </Grid>
                </Grid>
              </PopularCities>
            </Section>
          </ContentContainer>
        </Sections>
        <StyledFooter>
          <BottomLinksContainer>
            <StyledPrivacyLinks />
            <Grid container>
              <Grid item md={9}>
                <Copyright />
              </Grid>
              <Grid item md={3}>
                <SocialMedia />
              </Grid>
            </Grid>
          </BottomLinksContainer>
        </StyledFooter>
      </Fragment>
    );
  }
}

Desktop.propTypes = {
  popularCities: PropTypes.array,
  onPopularCityClick: PropTypes.func,
};

Desktop.defaultProps = {
  popularCities: [],
  onPopularCityClick: emptyFunction,
};

export default Desktop;
